import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import fetchMSSQLHook from "../../hooks/fetchMSSQL-hook";
import NoResults from "../../components/NoResults/NoResults";
import { NavigationContext } from "../../context/navigation-context";
import formHook from "../../hooks/form-hook";
import NotificationForm from "../../components/Modals/NotificationForm.js";

export default function Notifications() {
    const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const [levels, setLevels] = useState([]);
    const { fetchMssqlApi } = fetchMSSQLHook();
    const { setHeaderData } = useContext(NavigationContext);

    const { form, openForm, closeForm } = formHook();

    useEffect(() => {
        const saved = localStorage.getItem("autoRefreshEnabledNOTIF");
        const value = saved ? JSON.parse(saved) : true;
        setAutoRefreshEnabled(value);
    }, []);

    useEffect(() => {
        if (autoRefreshEnabled === null) return;
        if (autoRefreshEnabled) loadNotifications();
        else setNotifications([]);

        localStorage.setItem("autoRefreshEnabledNOTIF", JSON.stringify(autoRefreshEnabled));
    }, [autoRefreshEnabled]);

    const loadNotifications = () => {
        fetchMssqlApi("notifications", {}, res => {
            setNotifications(res[0]);
        });

        fetchMssqlApi("notification-levels", {}, res => {
            setLevels(res[0]);
        });
    };

    const handleSubmit = (evt, data) => {
        evt.preventDefault();

        fetchMssqlApi(
            "notifications/save",
            {
                method: "POST",
                data: {
                    notificationId: data.NotificationId,
                    levelId: data.UserNotificationLevelId ?? null
                }
            },
            (resp) => {
                loadNotifications();
                closeForm();
            }
        );
    };

    useEffect(() => {
        setHeaderData({ text: "Powiadomienia" });
        loadNotifications();
    }, []);

    return (
        <div className="container-fluid mt-3">
            <div className="container-fluid p-0 filter-icon-fix">
                <ul className="nav nav-tabs machine-tabs mb-1">
                    <li className="nav-item">
                        <Link to="/notifications">
                            <button className="nav-link btn" tabIndex="0">
                                Powiadomienia
                            </button>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/notifications-settings">
                            <button className="nav-link btn active" tabIndex="0">
                                Ustawienia
                            </button>
                        </Link>
                    </li>
                </ul>
            </div>

            {notifications.length ? (
                <div className="card">
                    <table className="table table-striped">
                        <thead>
                            <tr className="justify-content-center headers-color pe-none">
                                <th className="text-center">Nazwa powiadomienia</th>
                                <th className="text-center">Poziom domyślny</th>
                                <th className="text-center">Poziom użytkownika</th>
                                <th className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {notifications.map(n => {
                                const defaultLevel = levels.find(
                                    l => l.NotificationLevelId === n.DefaultNotificationLevelId
                                );
                                const userLevel = levels.find(
                                    l => l.NotificationLevelId === (n.UserNotificationLevelId ?? null)
                                );
                                return (
                                    <tr key={n.NotificationId}>
                                        <td className="text-center">{n.NotificationName}</td>
                                        <td className="text-center">
                                            <span
                                                className="badge bg-secondary text-white"
                                                style={{ padding: "9px", fontSize: "13px" }}
                                            >
                                                {defaultLevel ? defaultLevel.Name : "—"}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <span
                                                className="badge bg-primary text-white"
                                                style={{ padding: "9px", fontSize: "13px" }}
                                            >
                                                {userLevel
                                                    ? userLevel.Name
                                                    : defaultLevel?.Name ?? "—"}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={openForm(n.NotificationId)}
                                            >
                                                Edytuj
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <NoResults />
            )}

            {form && levels.length > 0 && (
                <NotificationForm
                    handleClose={closeForm}
                    handleSubmit={handleSubmit}
                    notification={notifications.find(n => n.NotificationId === form)}
                    levels={levels}
                />
            )}
        </div>
    );
}
